import _ from 'lodash';
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import TranInfoViewModal from '../../../components/inventorymng/history/TranInfoViewModal';
import { unloadInvTranInfo, viewInvTranInfo } from '../../../modules/inventoryModule/invTranInfo';
import * as invApi from '../../../lib/api/inventory';
import { listInventoryHistory } from '../../../modules/inventoryModule/invHistory';
import AskDialog from '../../../components/common/dialog/AskDialog';

const TranInfoViewModalContainer = ({ open, handleClose, id }) => {
    //처음 마운트 될 때 partenr 데이터 요청
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [totalPrice, setTotalPrice] = useState(0);
    const { transInf, productList, error, loading } = useSelector(
        ({ inventoryModule, loading }) => ({
            transInf: inventoryModule.invTranInfo.transInf,
            productList: inventoryModule.invTranInfo.productList,
            error: inventoryModule.invTranInfo.error,
            loading: loading['inventory/VIEW_INV_TRANINFO'],
        }),
    );

    useEffect(() => {
        dispatch(viewInvTranInfo(id));

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadInvTranInfo());
        };
    }, [dispatch, id]);

    useEffect(() => {
        if (productList && productList.length > 0) {
            let total = 0;
            _.forEach(productList, (p) => {
                total += parseInt(p.priceVal) * parseInt(p.productCnt);
            })

            setTotalPrice(total);
        }

        return () => {
            setTotalPrice(0);
        }
    }, [productList]);



    const [visible, setVisible] = useState(false);

    const onCancle = () => {
        setVisible(false);
    };

    const onConfirm = () => {
        setVisible(false);
        handleDel();
    };

    const onDelClick = () => {
        setVisible(true);
    }

    const handleDel = async () => {
        try {
            const res = await invApi.delTransInfo(transInf.trnUuid);
            if (res.data) {
                enqueueSnackbar('이력이 삭제 되었습니다', {
                    variant: 'success',
                });
                dispatch(listInventoryHistory());
                handleClose();
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
    }


    return (
        <>
            <TranInfoViewModal
                open={open}
                handleClose={handleClose}
                transInf={transInf}
                productList={productList}
                totalPrice={totalPrice}
                handleDel={onDelClick}
            />
            <AskDialog
                visible={visible}
                title="작업 취소(이력 삭제)"
                description="선택한 작업을 취소하시겠습니까?"
                confirmText="작업 취소"
                onConfirm={onConfirm}
                onCancle={onCancle}
            />
        </>

    )
}

export default TranInfoViewModalContainer